/* @flow */
import cx from 'classnames';
import React, { PropTypes } from 'react';

import Input from 'components/Input.jsx';
import Label from 'components/Label.jsx';
import ClickEventTrigger from 'components/ClickEventTrigger.jsx';

import './styles/Checkbox.scss';

/**
  * A React component for Checkbox. Leverages react-select
  * https://github.com/JedWatson/react-select
  */
class Checkbox extends React.Component {
  static propTypes = {
    label: PropTypes.node,
    labelNote: React.PropTypes.string,
    name: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    divided: PropTypes.bool,
    eventElementName: PropTypes.string,
    eventScreenName: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
    divided: false,
  };

  isChecked = () => {
    return this.refs.input.getInputNode().checked;
  };

  renderInput = (properties: Object) => {
    const input = (
      <Input
        {...properties}
        ref="input"
        type="checkbox"
        className="Checkbox-input"
      />
    );
    if (this.props.name && !this.props.disabled && this.props.checked) {
      const { eventScreenName } = this.props;
      const eventElementName = this.props.eventElementName || 'Checkbox';
      let eventProperties = {};
      eventProperties[this.props.name] = this.props.value;
      eventProperties = {
        toggle: this.props.checked ? 'no' : 'yes',
      };
      return (
        <ClickEventTrigger
          eventElementName={eventElementName}
          eventProperties={eventProperties}
          eventScreenName={eventScreenName}>
          {input}
        </ClickEventTrigger>
      );
    } else {
      return input;
    }
  };

  renderLabelNote = () => {
    if (this.props.labelNote) {
      return (
        <div className="Checkbox-labelNote">{this.props.labelNote}</div>
      );
    } else {
      return null;
    }
  };

  render() {
    const { className, label, children, ...others } = this.props;

    return (
      <Label
        className={cx('Checkbox', {
          'Checkbox--divided': this.props.divided,
          'Checkbox--noLabel': !this.props.label && !children,
        }, className)}>
        {this.renderInput(others)}
        <span className="Checkbox-indicator" />
        {label}
        {children}
        {this.renderLabelNote()}
      </Label>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox.jsx